<template>
  <div class="product-list-container">
    <div class="header">
      <search-input placeholder="Search for product"
                    class="search-input" />
      <primary-button @click.native="$router.push({name: 'company-admin-campaings-add-campaing'})"
                      class="primary-button">Add Campaign</primary-button>

    </div>
    <card-component style="margin-bottom: 20px"
                    title="Stats">
      <div class="grid-container">
        <div v-for="(stat, k) in statsData"
             :key="k"
             class="cont-grid">
          <div class="cont-grid-title">
            {{stat.name}}
          </div>
          <div class="cont-grid-price">
            $ {{stat.price}}
          </div>
          <div class="cont-grid-info">
            {{stat.amount}}
          </div>
        </div>
      </div>
    </card-component>
  </div>
</template>

<script>
export default {
  components: {
    SearchInput: () => import('@/components/Inputs/SearchInput.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
    CardComponent: () => import('@/components/CardComponent.vue'),
  },
  data: () => ({
    statsData: [
      {name: 'Current balance', price: 0.94, amount: ''},
      {name: 'SMS Sent', price: 0.94, amount: '0 messages'},
      {name: 'Inbound SMS', price: 0.94, amount: '0 messages'},
      {name: 'Shortcode', price: 0.94, amount: '0 messages'},
      {name: 'Shortcode in', price: 0.94, amount: '0 messages'},
      {name: 'Call routed', price: 0.94, amount: '0 Calls'},
      {name: 'Ringless voice', price: 0.94, amount: '0/0 RVMs'},
      {name: 'Phone', price: 0.94, amount: '0 phones'},
      {name: 'New Supperssions', price: 0.94, amount: ''},
      {name: 'Answered by human', price: 0.94, amount: ''},
      {name: 'Answered by machine', price: 0.94, amount: ''},
      {name: 'Press1 Answers', price: 0.94, amount: ''},
    ]
  })
}
</script>

<style lang="scss" scoped>
.product-list-container {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin-bottom: 20px;
    .search-input {
      max-width: 345px;
      height: 100%;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
  .grid-container {
    display: flex;
    flex-wrap: wrap;
    .cont-grid {
      width: 180px;
      height: 122px;
      .cont-grid-title {
        height: 30px;
        text-transform: uppercase;
        color: #bdbfd8;
        font-family: "Helvetica Neue";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 30px;
      }
      .cont-grid-price {
        height: 50px;
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 36px;
        font-weight: bold;
        line-height: 50px;
        margin-bottom: 7px;
      }
      .cont-grid-info {
        height: 15px;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 13px;
        line-height: 15px;
      }
    }
  }
}
</style>

